<template>
  <div class="bottom-box">
    <div class="main">
      <div class="logo">
        <img src="../../assets/better.png" class="icon" />
        <div class="text">项目经验，找有职</div>
        <div class="email">30655566112@qq.com</div>
      </div>

      <div class="tool">
        <div class="item">校招</div>
        <div class="item">会员信息表</div>
        <div class="item">职位</div>
        <div class="item">关于我们</div>
        <div class="item">商务合作</div>
        <div class="item">求职咨询</div>
      </div>

      <!-- 小程序推广 -->
      <div class="miniapp-box">
        <div class="miniApp">
          <img src="../../assets/miniapp.jpg" class="icon" />
          <div class="name">百特校园</div>
        </div>

        <div class="miniApp">
          <img src="../../assets/miniapp.jpg" class="icon" />
          <div class="name">百特校园</div>
        </div>

       
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.bottom-box {
  position: fixed;
  bottom: 0;
  z-index: 99;
  margin-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 150px;
  background-color: #fff;
  .main {
    display: flex;
    align-items: center;
    width: 50vw;
    .logo {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      height: 80px;
      .icon {
        width: 60px;
        height: 60px;
      }
      .text {
        font-size: 12px;
      }
      .email {
        font-size: 12px;
        color: #686969;
      }
    }

    .tool {
      display: flex;
      .item {
        margin-left: 30px;
        font-size: 15px;
        color: #686969;
      }
    }
    .miniapp-box {
      display: flex;
      margin-left: 100px;
      .miniApp {
        margin-left: 50px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .icon {
          width: 80px;
          height: 80px;
        }
        .name {
          font-size: 12px;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
